import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTrackEvent } from "@/hooks/useAnalytics";

export function PageViewTracker() {
  const location = useLocation();
  const trackEvent = useTrackEvent();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Token-gated URLs carry the signed token in the path — never persist or
    // forward them to third-party pixels. /oauth/consent is admin-only, not site traffic.
    if (/^\/(sign|pay|feedback|oauth)\//.test(location.pathname)) return;

    // Track page view on route change
    trackEvent.mutate({
      event_type: "page_view",
      page_path: location.pathname,
      referrer: document.referrer || undefined,
    });

    // Meta Pixel: o snippet base em index.html já dispara o PageView
    // inicial; aqui cobrimos as trocas de rota subsequentes do SPA.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    window.fbq?.("track", "PageView");
  }, [location.pathname]);

  return null;
}
